import { TripFolderBooking } from '../../lib/types/models/trip-folder/trip-folder'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderBookings(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.getTripBookings.url, { id }))
    .get<TripFolderBooking[]>()
}
